<template>
  <div>
    <div class="row">
      <div class="col-md-12 col-lg-12">
        <KTCodePreview v-bind:title="'Entidades Cadastradas'">
          <template v-slot:preview>
            <div col-md-2 col-lg-2>
              <v-btn
                v-if="verificarPermissao(permissoesPadrao.Incluir)"
                color="primary"
                fab
                x-small
                dark
                @click="novaEntidade"
                ><v-icon>mdi-plus</v-icon></v-btn
              >
            </div>
            <br />
            <v-row class="mb-5">
              <v-col cols="4">
                <v-select
                  :items="departamentos"
                  label="Departamento"
                  item-text="caminhoCompleto"
                  item-value="id"
                  v-model="filtro.departamentoID"
                  :rules="[rules.required]"
                  required
                  @change="listaEmpresas()"
                ></v-select>
              </v-col>
              <v-col cols="4">
                <v-select
                  :items="empresas"
                  label="Empresa"
                  :item-text="(item) => item.nome + ' - ' + item.id"
                  item-value="id"
                  v-model="filtro.empresaID"
                  :disabled="filtro.departamentoID == 0"
                  :rules="[rules.required]"
                  required
                  @change="searchDepartamentosTimeOut()"
                ></v-select>
              </v-col>
              <v-col cols="3" align-self="end">
                <v-switch
                  @change="listaEmpresas()"
                  v-model="listarApenasEmpresasVigentes"
                >
                  <template #label> Ver Apenas Empresas Vigentes </template>
                </v-switch>
              </v-col>
            </v-row>
            <p>
              <v-btn
                :disabled="!filtro.empresaID || !filtro.departamentoID"
                @click="pesquisar()"
                color="primary"
                large
                class="ml-2"
                >Pesquisar</v-btn
              >
            </p>
            <div>
              <v-row>
                <v-col cols="3" align-self="end">
                  <v-switch
                    @change="pesquisar()"
                    v-model="listarApenasVigentes"
                  >
                    <template #label> Ver Apenas Vigentes </template>
                  </v-switch>
                </v-col>
                <v-col cols="3" align-self="end">
                  <v-switch @change="pesquisar()" v-model="listarInativos">
                    <template #label> Ver Inativos </template>
                  </v-switch>
                </v-col>
              </v-row>
            </div>
            <div v-if="entidades.length == 0 && pesquisado">
              <v-row>
                <v-alert dense outlined type="info">
                  Nenhuma entidade encontrada
                </v-alert>
              </v-row>
            </div>
            <div v-if="entidades.length > 0">
              <v-row>
                <v-col cols="6" offset="6">
                  <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Pesquisa"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-data-table
                :headers="headers"
                :items="entidades"
                :search="search"
                :custom-filter="customFilter"
                :items-per-page.sync="itemsPerPage"
                :page.sync="page"
              >
                <template v-slot:header.entidadePropriedadeValores="{ header }">
                  <v-row class="d-flex align-center justify-md-space-between">
                    <span>Entidades</span>
                    <v-menu
                      offset-y
                      close-on-content-click
                      allow-overflow
                      max-height="200px"
                    >
                      <template v-slot:activator="{ on: menu, attrs }">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on: tooltip }">
                            <v-btn
                              v-bind="attrs"
                              v-on="{ ...menu, ...tooltip }"
                              icon
                              x-small
                            >
                              <v-icon>mdi-arrow-down</v-icon>
                            </v-btn>
                          </template>
                          <span>Ordenar por</span>
                        </v-tooltip>
                      </template>
                      <v-list>
                        <v-list-item
                          v-for="prop in propriedadesOrdenacao"
                          :key="prop"
                          @click="ordenacao(prop)"
                        >
                          <v-list-item-title
                            >{{ prop }}
                            <v-icon small v-if="prop == ordenacaoAtiva.nome">
                              {{
                                ordenacaoAtiva.type == "desc"
                                  ? "mdi-arrow-down"
                                  : "mdi-arrow-up"
                              }}
                            </v-icon>
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-row>
                </template>
                <template v-slot:item.entidadePropriedadeValores="{ item }">
                  <td>
                    <div
                      v-for="prop in item.entidadePropriedadeValores"
                      :key="prop.id"
                      class="mt-2 mb-2"
                    >
                      <span
                        ><strong
                          >{{ prop.grupoPropriedade.nome }}:
                        </strong></span
                      >&nbsp;
                      <span>{{ prop.valor }}</span>
                    </div>
                  </td>
                </template>
                <template v-slot:item.grupo.icone="{ item }">
                  <v-icon v-if="item.grupo.icone">{{
                    item.grupo.icone
                  }}</v-icon>
                </template>
                <template v-slot:item.acao="{ item }">
                  <v-flex>
                    <v-btn
                      v-if="
                        item.dataVigenciaFim == null &&
                        verificarPermissao(permissoesPadrao.Editar)
                      "
                      color="warning"
                      fab
                      x-small
                      dark
                      @click="editar(item.id)"
                      class="ml-2"
                      ><v-icon>mdi-pencil</v-icon></v-btn
                    >
                    <v-btn
                      v-if="verificarPermissao(permissoesPadrao.Excluir)"
                      color="error"
                      fab
                      x-small
                      dark
                      @click="inativar(item.id, index)"
                      class="ml-2"
                      title="Inativar"
                      ><v-icon>mdi-trash-can</v-icon></v-btn
                    >
                    <v-btn
                      color="primary"
                      fab
                      x-small
                      dark
                      @click="historico(item.id)"
                      class="ml-2"
                      title="Visualizar historico"
                      ><v-icon> mdi-eye</v-icon></v-btn
                    >
                    <v-btn
                      color="red"
                      fab
                      x-small
                      dark
                      class="ml-2"
                      title="Anular pendências após fim da vigência"
                      :loading="
                        carregandoAnularPendencias &&
                        idAtualProcessando == item.id
                      "
                      @click="setAnularPendencias(item, true)"
                      v-if="
                        !item.anularPendenciasAposDataVegenciaFim &&
                        item.dataVigenciaFim != null
                      "
                      ><v-icon>mdi-cancel</v-icon></v-btn
                    >

                    <v-btn
                      :loading="
                        carregandoAnularPendencias &&
                        idAtualProcessando == item.id
                      "
                      color="green"
                      fab
                      x-small
                      dark
                      class="ml-2"
                      title="Liberar pendências após fim da vigência"
                      @click="setAnularPendencias(item, false)"
                      v-if="
                        item.anularPendenciasAposDataVegenciaFim &&
                        item.dataVigenciaFim != null
                      "
                      ><v-icon>mdi-check-circle</v-icon></v-btn
                    >

                    <v-btn
                      color="orange"
                      fab
                      x-small
                      dark
                      class="ml-2"
                      title="Anular todas pendências"
                      :loading="
                        carregandoAnularTodasPendencias &&
                        idAtualProcessando == item.id
                      "
                      @click="setAnularTodasPendencias(item, true)"
                      v-if="
                        !item.anularTodasPendencias &&
                        item.dataVigenciaFim != null
                      "
                      ><v-icon>mdi-cancel</v-icon></v-btn
                    >

                    <v-btn
                      :loading="
                        carregandoAnularTodasPendencias &&
                        idAtualProcessando == item.id
                      "
                      color="blue"
                      fab
                      x-small
                      dark
                      class="ml-2"
                      title="Liberar todas pendências"
                      @click="setAnularTodasPendencias(item, false)"
                      v-if="
                        item.anularTodasPendencias &&
                        item.dataVigenciaFim != null
                      "
                      ><v-icon>mdi-check-circle</v-icon></v-btn
                    >
                  </v-flex>
                </template>
              </v-data-table>
            </div>
          </template>
        </KTCodePreview>
        <TelaLoading :overlay="loading"></TelaLoading>
      </div>
    </div>
  </div>
</template>

<script>
import KTCodePreview from "@/views/partials/content/CodePreview.vue";
import ApiService from "@/common/services/http/api.service";
import Swal from "sweetalert2";
import SweetAlert from "@/common/services/sweetalert.service";
import Permissoes from "@/common/services/permissoes/permissoes.js";
import Modulo from "@/common/services/permissoes/modulos.js";
import PermissoesService from "@/common/services/permissoes/permissoes.service.js";
import TelaLoading from "@/views/components/TelaLoading.vue";

export default {
  name: "entidade",
  data() {
    return {
      listarApenasEmpresasVigentes: true,
      page: 1,
      listarInativos: false,
      listarApenasVigentes: true,
      loading: false,
      itemsPerPage: 1,
      permissoesPadrao: {},
      rules: {
        required: (v) => !!v || "Obrigatório",
      },
      filtro: {
        empresaID: 0,
        departamentoID: 0,
        grupoID: 0,
      },
      entidades: [],
      grupos: [],
      departamentos: [],
      search: "",
      headers: [
        { text: "ID", value: "id" },
        {
          text: "Entidade",
          value: "entidadePropriedadeValores",
          sortable: false,
        },
        { text: "Inicio Data Vigencia", value: "dataVigenciaInicioExibicao" },
        {
          text: "Fim Data Vigencia",
          value: "dataVigenciaFimExibicao",
        },
        { text: "", value: "grupo.icone" },
        { text: "Grupo", value: "grupo.nome" },
        { text: "Empresa", value: "empresa.nome" },
        { text: "Departamento", value: "departamento.nome" },
        { text: "", value: "acao", sortable: false, width: "15%" },
      ],
      ordenacaoAtiva: {
        nome: undefined,
        type: undefined,
      },
      cliente: {},
      usuario: {},
      empresas: [],
      pesquisado: false,
      propriedadesOrdenacao: [],
      carregandoAnularPendencias: false,
      carregandoAnularTodasPendencias: false,
      idAtualProcessando: 0,
    };
  },
  components: {
    KTCodePreview,
    TelaLoading,
  },
  methods: {
    propriedadeInteligente() {
      const propriedades = [];
      this.entidades.forEach((f) => {
        f.entidadePropriedadeValores.forEach((gp) => {
          propriedades.push(gp.grupoPropriedade.nome);
        });
      });
      this.propriedadesOrdenacao = [...new Set(propriedades)];
    },
    ordenacao(prop) {
      if (this.ordenacaoAtiva.nome != prop) {
        this.ordenacaoAtiva.nome = prop;
        this.ordenacaoAtiva.type = undefined;
      }
      this.ordenacaoAtiva.type =
        this.ordenacaoAtiva.type == "asc" ? "desc" : "asc";

      if (this.ordenacaoAtiva == prop) {
        this.entidades = this.entidades.reverse();
        return;
      }
      this.entidades = this.entidades
        .sort((a, b) => this.ordenacaoPorProp(a, b, prop))
        .slice();
      if (this.ordenacaoAtiva.type == "desc") {
        this.entidades = this.entidades.reverse();
      }
    },
    ordenacaoPorProp(a, b, prop) {
      const nomeA = a.entidadePropriedadeValores
        .find((p) => p.grupoPropriedade.nome == prop)
        ?.valor.trim();
      const nomeB = b.entidadePropriedadeValores
        .find((p) => p.grupoPropriedade.nome == prop)
        ?.valor.trim();

      if (!nomeA && !nomeB) return 0;
      if (!nomeA) return 1;
      if (!nomeB) return -1;
      if (nomeA > nomeB) return 1;
      if (nomeA < nomeB) return -1;
      return 0;
    },
    ordenacaoPorNome(a, b) {
      const nomeA = (
        a.entidadePropriedadeValores.find(
          (p) => p.grupoPropriedade.nome == "Nome Completo"
        ) ??
        a.entidadePropriedadeValores.find(
          (p) => p.grupoPropriedade.nome == "Razão Social"
        )
      )?.valor.trim();
      const nomeB = (
        b.entidadePropriedadeValores.find(
          (p) => p.grupoPropriedade.nome == "Nome Completo"
        ) ??
        b.entidadePropriedadeValores.find(
          (p) => p.grupoPropriedade.nome == "Razão Social"
        )
      )?.valor.trim();
      if (!nomeA && !nomeB) return 0;
      if (!nomeA) return 1;
      if (!nomeB) return -1;
      if (nomeA > nomeB) return 1;
      if (nomeA < nomeB) return -1;
      return 0;
    },
    ordenacaoPorDocumento(a, b) {
      const documentoA = (
        a.entidadePropriedadeValores.find(
          (p) => p.grupoPropriedade.nome == "CNPJ"
        ) ??
        a.entidadePropriedadeValores.find(
          (p) => p.grupoPropriedade.nome == "CPF"
        )
      ).valor?.trim();
      const documentoB = (
        b.entidadePropriedadeValores.find(
          (p) => p.grupoPropriedade.nome == "CNPJ"
        ) ??
        b.entidadePropriedadeValores.find(
          (p) => p.grupoPropriedade.nome == "CPF"
        )
      ).valor?.trim();

      if (!documentoA && !documentoB) return 0;
      if (!documentoA) return 1;
      if (!documentoB) return -1;
      if (documentoA > documentoB) return 1;
      if (documentoA < documentoB) return -1;
      return 0;
    },
    async beforeDownload() {},
    async listaGrupos() {
      this.grupos = [];

      const { data: result } = await ApiService.get(
        "grupo/getByDepartamentoID/" + this.filtro.departamentoID
      );

      if (result.success) this.grupos = result.data;
      else SweetAlert.sweetAlertError(result.errors);
    },
    async listaEmpresas() {
      this.filtro.empresaID = 0;
      let empresas = [];

      if (this.usuario.usuario.tipoUsuario === 4) {
        const { data: result } = await ApiService.get(
          "empresa/getbyusuarioedepartamentoidsimples/" +
            this.usuario.usuario.id +
            "/" +
            this.filtro.departamentoID
        );

        if (result.success && result.data != null) {
          if (this.listarApenasEmpresasVigentes)
            empresas = result.data.filter((x) => x.dataVigenciaFim == null);
          else empresas = result.data;
        } else SweetAlert.sweetAlertError(result.errors);
      } else {
        const { data: result } = await ApiService.get(
          "empresa/getbydepartamentoidsimples/" + this.filtro.departamentoID
        );

        if (result.success && result.data != null) {
          if (this.listarApenasEmpresasVigentes)
            empresas = result.data.filter((x) => x.dataVigenciaFim == null);
          else empresas = result.data;
        } else SweetAlert.sweetAlertError(result.errors);
      }

      this.empresas = empresas;
    },
    async setAnularPendencias(item, valor) {
      this.carregandoAnularPendencias = true;
      this.idAtualProcessando = item.id;
      const { data: result } = await ApiService.put(
        "entidade/setAnularPendenciasAposDataVigenciaFim/" + item.id,
        { value: valor }
      );

      if (result.success) {
        item.anularPendenciasAposDataVegenciaFim = valor;
      } 
      else 
      {
        SweetAlert.sweetAlertError(result.errors);
      }
      this.carregandoAnularPendencias = false;
      this.idAtualProcessando = 0;
    },
    async setAnularTodasPendencias(item, valor) {
      this.carregandoAnularTodasPendencias = true;
      this.idAtualProcessando = item.id;
      const { data: result } = await ApiService.put(
        "entidade/setAnularTodasPendencias/" + item.id,
        { value: valor }
      );

      if (result.success) {
        item.anularTodasPendencias = valor
      }
      else 
      {
        SweetAlert.sweetAlertError(result.errors);
      }
      this.carregandoAnularTodasPendencias = false;
      this.idAtualProcessando = 0;
    },
    customFilter(value, search, item) {
      if (
        value != null &&
        search != null &&
        typeof value === "string" &&
        value.toString().toLowerCase().indexOf(search.toLowerCase()) !== -1
      ) {
        return true;
      }

      for (
        let index = 0;
        index < item.entidadePropriedadeValores.length;
        index++
      ) {
        const propriedade = item.entidadePropriedadeValores[index];

        if (
          propriedade.valor
            .toString()
            .toLowerCase()
            .indexOf(search.toLowerCase()) !== -1
        ) {
          return true;
        }

        if (
          propriedade.grupoPropriedade.nome
            .toString()
            .toLowerCase()
            .indexOf(search.toLowerCase()) !== -1
        ) {
          return true;
        }
      }

      return false;
    },

    novaEntidade() {
      this.popularPaginacaoEFiltrosEntidade();
      this.$router.push({ name: "entidadeCadastro" });
    },

    verificarPermissao(permissao) {
      return PermissoesService.verificarAcesso(Modulo.Entidade, permissao);
    },

    popularPaginacaoEFiltrosEntidade() {
      const tabelaEntidade = {
        page: this.page,
        itemsPerPage: this.itemsPerPage,
        empresaID: this.filtro.empresaID,
        grupoID: this.filtro.grupoID,
        departamentoID: this.filtro.departamentoID,
      };

      sessionStorage.setItem("tabelaEntidade", JSON.stringify(tabelaEntidade));
    },

    pesquisar() {
      this.listaEntidades();
    },

    listaEntidades() {
      if (!this.filtro.departamentoID || !this.filtro.empresaID) {
        return;
      }

      this.pesquisado = false;
      return new Promise((resolve) => {
        ApiService.get(
          `entidade/listar/empresa/${this.filtro.empresaID}/departamento/${this.filtro.departamentoID}`,
          "",
          {
            inativos: this.listarInativos,
            apenasVigentes: this.listarApenasVigentes,
          }
        ).then(({ data }) => {
          if (data.success) {
            resolve(data);
            this.page = 1;
            this.itemsPerPage = 10;

            const tabelaEntidade = sessionStorage.getItem("tabelaEntidade")
              ? JSON.parse(sessionStorage.getItem("tabelaEntidade"))
              : null;

            if (tabelaEntidade) {
              this.itemsPerPage = tabelaEntidade.itemsPerPage;
              this.page = tabelaEntidade.page;
            }

            sessionStorage.removeItem("tabelaEntidade");
            this.entidades = data.data;
            this.propriedadeInteligente();

            this.pesquisado = true;
            this.carregandoAnularPendencias = false;
            this.carregandoAnularTodasPendencias = false;
          } else SweetAlert.sweetAlertError(data.errors);
        });
      });
    },

    editar(id) {
      this.popularPaginacaoEFiltrosEntidade();

      this.$router.push({ path: "entidade/cadastro/" + id });
    },

    historico(id) {
      this.popularPaginacaoEFiltrosEntidade();

      this.$router.push({ path: "entidade/historico/" + id });
    },

    inativar(id, index) {
      let self = this;

      Swal.fire({
        title: "Tem certeza que deseja excluir esse registro?",
        text: "Essa operação não poderá ser desfeita!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim, pode excluir!",
      }).then(function (result) {
        if (result.value) {
          return new Promise((resolve) => {
            ApiService.put("entidade/" + id + "/inativar").then(({ data }) => {
              resolve(data);

              if (data.success === true) {
                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "Entidade Inativada com Sucesso!",
                  showConfirmButton: false,
                  timer: 1500,
                }).then(function () {
                  self.entidades.splice(index, 1);
                });
              } else SweetAlert.sweetAlertError(data.errors);
            });
          });
        }
      });
    },

    async listaDepartamentos() {
      let departamentos = [];

      const { data: result } = await ApiService.get(
        "departamento/getbyclienteid/" + this.cliente.id
      );

      if (result.success) departamentos = result.data;
      else SweetAlert.sweetAlertError(result.errors);

      this.departamentos = departamentos;
    },

    async preencherFiltrosAutomaticamente() {
      const tabelaEntidade = JSON.parse(
        sessionStorage.getItem("tabelaEntidade")
      );

      const empresaID = tabelaEntidade.empresaID;
      const departamentoID = tabelaEntidade.departamentoID;
      await this.listaDepartamentos();

      this.filtro.departamentoID = departamentoID;

      await this.listaEmpresas();

      this.filtro.empresaID = empresaID;

      await this.listaEntidades();

      sessionStorage.removeItem("tabelaEntidade");
    },

    searchDepartamentosTimeOut() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {}, 500);
    },

    exportarPDFNotificacao(id, nome) {
      this.loading = true;
      let self = this;
      return new Promise((resolve) => {
        ApiService.download(
          `grupo/obter-notificacao/pdf/${id}/${this.cliente.id}`
        )
          .then(({ data }) => {
            const url = window.URL.createObjectURL(
              new Blob([data], { type: "application/pdf" })
            );
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `Notificação-Agregadas-${nome}.pdf`);
            document.body.appendChild(link);
            link.click();
            resolve(data);
          })
          .catch(() =>
            SweetAlert.sweetAlertError(["Erro ao exportar notificação"])
          )
          .finally(() => (self.loading = false));
      });
    },
  },
  mounted() {
    this.cliente = JSON.parse(window.localStorage.getItem("cliente"));
    this.usuario = JSON.parse(window.localStorage.getItem("usuario"));
    this.permissoesPadrao = Permissoes;
    const tabelaEntidade = sessionStorage.getItem("tabelaEntidade")
      ? JSON.parse(sessionStorage.getItem("tabelaEntidade"))
      : null;

    if (tabelaEntidade) {
      this.preencherFiltrosAutomaticamente();
    } else {
      this.listaDepartamentos();
    }
  },
  created() {
    if (
      !PermissoesService.verificarAcesso(Modulo.Entidade, Permissoes.Visualizar)
    ) {
      SweetAlert.sweetAlertError([
        "Você não tem permissão para acessar essa parte do sistema",
      ]);
      this.$router.push({ name: "index" });
    }
  },
};
</script>
